import { IFooterButtons } from '@core/interface';
import { COUNTRY_CODE } from '@core/enums';

export const getCountryFooterButtons = (country: string): IFooterButtons => {
  const countryFooterButtons: Record<string, IFooterButtons> = {
    [COUNTRY_CODE.BRAZIL]: {
      terms: {
        label: 'footer.terms-conditions',
        url: '',
      },
      privacy: {
        label: 'footer.privacy-policy',
        url: 'https://www.ford.com.br/politica-de-privacidade/',
      },
      rights: {
        label: 'footer.rights',
        url: 'https://www.relacionamentoford.com.br/?utm_medium=referral&utm_source=site-ford&utm_campaign=lgpd&utm_content=0&utm_term=0',
      }
    },
    [COUNTRY_CODE.ARGENTINA]: {
      terms: {
        label: 'footer.terms-conditions',
        url: 'https://www.ford.com.ar/politicas/',
      },
      privacy: {
        label: 'footer.privacy-policy',
        url: ''
      },
      rights: {
        label: 'footer.rights',
        url: '',
      }
    },
    [COUNTRY_CODE.CHILE]: {
      terms: {
        label: 'footer.terms-conditions',
        url: 'https://www.ford.cl/politica-de-privacidad/',
      },
      privacy: {
        label: 'footer.privacy-policy',
        url: ''
      },
      rights: {
        label: 'footer.rights',
        url: '',
      }
    },
    [COUNTRY_CODE.PERU]: {
      terms: {
        label: 'footer.terms-conditions',
        url: 'https://www.ford.pe/terminos-condiciones/',
      },
      privacy: {
        label: 'footer.privacy-policy',
        url: 'https://www.ford.pe/politicas-de-privacidad/',
      },
      rights: {
        label: 'footer.rights',
        url: '',
      }
    },
    [COUNTRY_CODE.ECUADOR]: {
      terms: {
        label: 'footer.terms-conditions',
        url: '',
      },
      privacy: {
        label: 'footer.privacy-policy',
        url: 'https://www.ford.com.ec/copyright/',
      },
      rights: {
        label: 'footer.rights',
        url: 'https://www.ford.com.ec/copyright/',
      }
    },
    [COUNTRY_CODE.COLOMBIA]: {
      terms: {
        label: 'footer.terms-conditions',
        url: 'https://www.ford.com.co/copyright/',
      },
      privacy: {
        label: 'footer.privacy-policy',
        url: 'https://www.ford.com.co/politica-tratamiento-datos/',
      },
      rights: {
        label: 'footer.rights',
        url: '',
      }
    },
    [COUNTRY_CODE.VENEZUELA]: {
      terms: {
        label: 'footer.terms-conditions',
        url: '',
      },
      privacy: {
        label: 'footer.privacy-policy',
        url: 'https://www.ford.com.ve/terminos-y-condiciones/',
      },
      rights: {
        label: 'footer.rights',
        url: 'https://www.ford.com.ve/terminos-y-condiciones/',
      }
    },
  };
  return countryFooterButtons[country];
};
